import { render, staticRenderFns } from "./Higher.vue?vue&type=template&id=292d7b27&"
import script from "./Higher.vue?vue&type=script&lang=js&"
export * from "./Higher.vue?vue&type=script&lang=js&"
import style0 from "./Higher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports